/* ============================================================
   title-animation.js — Urdile (v9)
   - Título: EQ rápido (~33fps) con círculos alternando ⚪/🔵 y
     parlante 🔊/🔉/🔈 al final del texto "Urdile".
   - Separador · entre el EQ y "Urdile".
   - Favicon estático (no se anima).
   - Solo corre cuando la tab está oculta (visibilitychange).
   ============================================================ */
(function() {
  'use strict';

  // 20 frames: círculos alternan ⚪/🔵, barras EQ varían, parlante rota 🔊/🔉/🔈
  var FRAMES = [
    '⚪ █▁▃ ⚪ · Urdile 🔊',
    '🔵 ▁█▆ 🔵 · Urdile 🔉',
    '⚪ ▆▂█ ⚪ · Urdile 🔈',
    '🔵 ▃█▁ 🔵 · Urdile 🔊',
    '⚪ █▅▂ ⚪ · Urdile 🔉',
    '🔵 ▂▇█ 🔵 · Urdile 🔈',
    '⚪ ▇▁▅ ⚪ · Urdile 🔊',
    '🔵 ▄█▃ 🔵 · Urdile 🔉',
    '⚪ ▁▆█ ⚪ · Urdile 🔈',
    '🔵 █▃▆ 🔵 · Urdile 🔊',
    '⚪ ▅█▁ ⚪ · Urdile 🔉',
    '🔵 ▆▂█ 🔵 · Urdile 🔈',
    '⚪ ▃█▅ ⚪ · Urdile 🔊',
    '🔵 █▆▂ 🔵 · Urdile 🔉',
    '⚪ ▂█▇ ⚪ · Urdile 🔈',
    '🔵 ▇▁█ 🔵 · Urdile 🔊',
    '⚪ ▁▇▃ ⚪ · Urdile 🔉',
    '🔵 █▄▆ 🔵 · Urdile 🔈',
    '⚪ ▆█▁ ⚪ · Urdile 🔊',
    '🔵 ▃▆█ 🔵 · Urdile 🔉',
  ];
  var FRAME_MS = 30; // ~33fps — al límite de update del browser

  var originalTitle = document.title;
  var frameIdx = 0;
  var timer = null;
  var isAnimating = false;

  function tick() {
    document.title = FRAMES[frameIdx];
    frameIdx = (frameIdx + 1) % FRAMES.length;
  }

  function start() {
    if (isAnimating) return;
    originalTitle = document.title;
    isAnimating = true;
    frameIdx = 0;
    tick(); // primer frame inmediato
    timer = setInterval(tick, FRAME_MS);
  }

  function stop() {
    if (!isAnimating) return;
    isAnimating = false;
    if (timer) { clearInterval(timer); timer = null; }
    if (originalTitle) document.title = originalTitle;
  }

  document.addEventListener('visibilitychange', function() {
    if (document.hidden) start();
    else stop();
  });
  window.addEventListener('beforeunload', stop);
  if (document.hidden) start();
})();
